import React from 'react'
import { Icon, IconButton, Tooltip } from '@chakra-ui/react'
import { FaSync } from 'react-icons/fa'
import { RefreshButtonProps } from '../types'

const RefreshButton: React.FC<RefreshButtonProps> = ({ 
  isRefreshing, 
  onRefresh 
}) => (
  <Tooltip hasArrow label="Refresh data" placement="top">
    <IconButton
      aria-label="Refresh data"
      colorScheme="blue"
      icon={<Icon as={FaSync as any} />}
      isLoading={isRefreshing}
      onClick={onRefresh}
      size="md"
      variant="ghost"
    />
  </Tooltip>
)

export default RefreshButton
